import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared.module';
import { ManageVatStepsComponent } from '../../manage-vat-automatically/manage-vat-steps/manage-vat-steps.component';
import { GridModule } from './grid.module';

@NgModule({
  imports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    GridModule
  ],
  declarations: [
    ManageVatStepsComponent
  ],
  exports: [
    ManageVatStepsComponent
  ]
})
export class ManageVatStepsModule { }
